@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@font-size: 14px;
@short-width: 185px;
@standard-height: 32px;
@short-height: 24px;

.widget-section {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--gray-DFE4E8);

  > * {
    width: 100%;
  }
}

.widget-section:empty {
  display: none;
}

.standard-dropdown {
  height: @standard-height;
}

.standard-input {
  width: 100%;
  height: @standard-height;

  input {
    border-color: initial;
  }
}

.quantity-input {
  height: @standard-height;
  input {
    text-align: right;
  }
}

.currency-input {
  height: @standard-height;
  flex: 1;
  > input {
    text-align: right;
  }
}

.weight-input {
  height: @standard-height;
  > input {
    text-align: right;
  }
}

.vert-center {
  display: flex;
  align-items: center;
}

.currency-code {
  padding-left: 5px;
  font-weight: @bold;
}

.remove {
  svg {
    transform: scale(0.3);
    opacity: 0.25;
  }
  &:hover {
    svg {
      opacity: 0.75;
    }
  }
}

.label-with-tooltip {
  align-items: center;
}
